import { Box, BoxProps, HStack, Text } from '@chakra-ui/react'
import React, { FC } from 'react'
import { useColor } from '../../../theme/useColor'
import { Error as ErrorIcon } from '../../../icons'

export const GeneralError: FC<BoxProps> = ({
  children,
  ...boxProps
}) => {
  const errorBackgroundColor = useColor({ palette: 'red', nuance: 1 })
  const errorTextColor = useColor({ palette: 'text', nuance: 6 })

  return (
    <HStack
      backgroundColor={errorBackgroundColor}
      borderRadius="10"
      paddingX="6"
      paddingY="3"
      {...boxProps}>
      <Box height={4} position="relative" width={4}>
        <Box
          backgroundColor="white"
          borderRadius="full"
          height={3}
          left={0.5}
          position="absolute"
          top={0.5}
          width={3}
        />
        <ErrorIcon color={errorTextColor} position="absolute" />
      </Box>
      <Text color={errorTextColor} fontSize="sm">
        {children}
      </Text>
    </HStack>
  )
}
